// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"28a9878d","453":"23c7c109","640":"e2f116c9"}[chunkId] + ".chunk.js";
};